import { Base64 } from 'js-base64';

export const base64 = { encode, decode: Base64.decode, toBytes };

interface EncodeOptions {
  urlSafe?: boolean;
}

function encode(input: string, options: EncodeOptions = {}): string {
  const { urlSafe = false } = options;
  return Base64.encode(input, urlSafe);
}

/**
 * Decodes base64 to raw bytes, accepting the standard and URL-safe alphabets and
 * tolerating absent padding.
 *
 * Use this rather than `decode` for anything that is not text: `decode` performs
 * a UTF-8 decode, which corrupts arbitrary binary such as a signature.
 *
 * Returns Uint8Array<ArrayBuffer> rather than a plain Uint8Array because
 * crypto.subtle only accepts a BufferSource backed by a real ArrayBuffer.
 */
function toBytes(value: string): Uint8Array<ArrayBuffer> {
  const standard = value.replace(/-/g, '+').replace(/_/g, '/');
  const binary = atob(standard + '='.repeat((4 - (standard.length % 4)) % 4));
  const bytes = new Uint8Array(new ArrayBuffer(binary.length));
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}
